import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { CalendsurveyComponent } from './calendsurvey.component';
import { TranslateModule } from '@ngx-translate/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AuthGuard } from 'app/auth/auth.guard';
import { AuthAdminGuard } from 'app/auth/auth-admin.guard';
import {MatDatepickerModule} from '@angular/material/datepicker';
// SERVICIO AUTORIZACION E INTERCEPTION DE TOKEN
import { FullCalendarModule } from '@fullcalendar/angular';
import {MatFormFieldModule} from '@angular/material/form-field'; // must go before plugins
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import dayGridPlugin from '@fullcalendar/daygrid'; // a plugin!
import interactionPlugin from '@fullcalendar/interaction'; // a plugin!
import { ModalCalendInfoComponent } from './modal-calend-info/modal-calend-info.component';
import {MatSelectModule} from '@angular/material/select';
import {MatIconModule} from '@angular/material/icon';
import {MatListModule} from '@angular/material/list';
import {MatDividerModule} from '@angular/material/divider';
import { FlexLayoutModule } from "@angular/flex-layout";
import { DatePipe } from '@angular/common';
FullCalendarModule.registerPlugins([ // register FullCalendar plugins
  dayGridPlugin,
  interactionPlugin
]);

const routes : Routes = [
  {
    path     : 'calend-survey',
    component: CalendsurveyComponent,
    canActivate: [AuthGuard, AuthAdminGuard]
  },
];


@NgModule({
  declarations: [
    CalendsurveyComponent,ModalCalendInfoComponent
  ],
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    TranslateModule,
    BrowserAnimationsModule,
    FullCalendarModule,
    MatDatepickerModule,
    MatFormFieldModule,
    FormsModule,
    ReactiveFormsModule,
    MatSelectModule,
    MatIconModule,
    MatListModule,
    MatDividerModule,
    FlexLayoutModule,
  ],
  entryComponents: [ModalCalendInfoComponent],
  providers: [DatePipe],
})
export class CalendsurveyModule { }
